import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

export function useGoogleDriveStatus() {
    return useQuery({
        queryKey: ["google-drive-status"],
        queryFn: async () => {
            const res = await apiClient.getGoogleDriveStatus();
            if (res.status !== 200) {
                throw new Error("Failed to fetch Google Drive status");
            }
            return res.body;
        },
    });
}

export function useGoogleDriveSyncPolling(jobId: string | null) {
    return useQuery({
        queryKey: ["google-drive-sync", jobId],
        queryFn: async () => {
            if (!jobId) throw new Error("No job ID");
            const res = await apiClient.getGoogleDriveSyncStatus({ params: { jobId } });
            if (res.status !== 200) {
                throw new Error("Failed to fetch sync status");
            }
            return res.body;
        },
        enabled: !!jobId,
        refetchInterval: (query) => {
            const status = query.state.data?.status;
            if (status === "completed" || status === "failed") return false;
            return 3000;
        },
    });
}
